<template>
  <v-app>
    <app-bar :keycloak="keycloak"/>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar';

export default {
  name: 'App',
  props: ['keycloak'],
  components: {
    AppBar
  }
};
</script>
